<h2 mat-dialog-title>Aggiungi Lavorazione</h2>
<mat-dialog-content  class="mat-typography">
  <div class="form-container">
    <form [formGroup]="registerForm">
      <h2>Inserisci i dettagli della lavorazione</h2>
      
      <mat-form-field appearance="fill" class="full-width" [style.display]="getConfigurazione()?.Stato !== 'none' ? 'block' : 'none'">
        <mat-label>Stato</mat-label>
        <mat-select formControlName="selectedValueStato" name="stato" [disabled]="isStatolavorazionedisabled()" (selectionChange)="manageChangeStato()">
          <mat-option *ngFor="let stato of stati" [value]="stato.Nome">
            {{stato.Nome}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width" [style.display]="getConfigurazione()?.Tipolavorazione !== 'none' ? 'block' : 'none'">
        <mat-label>Tipo lavorazione</mat-label>
        <mat-select formControlName="selectedValueTipolavorazione" name="tipolavorazione" (selectionChange)="manageChangeTipolavorazione()">
          <mat-option *ngFor="let tipolavorazione of tipilavorazione" [value]="tipolavorazione.Nome">
            {{tipolavorazione.Nome}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width" [style.display]="getConfigurazione()?.Codice !== 'none' ? 'block' : 'none'">
        <mat-label>Codice</mat-label>
        <input matInput formControlName="Codice" name="Codice">
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width" [style.display]="getConfigurazione()?.Codicecommessa !== 'none' ? 'block' : 'none'">
        <mat-label>Codice commessa</mat-label>
        <input matInput formControlName="Codicecommessa" name="Codicecommessa">
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width" [style.display]="getConfigurazione()?.Codicestatolavorazione !== 'none' ? 'block' : 'none'">
        <mat-label>Codice stato lavorazione</mat-label>
        <input matInput formControlName="Codicestatolavorazione" name="Codicestatolavorazione">
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width" [style.display]="getConfigurazione()?.Codicetipolavorazione !== 'none' ? 'block' : 'none'">
        <mat-label>Codice tipo lavorazione</mat-label>
        <input matInput formControlName="Codicetipolavorazione" name="Codicetipolavorazione">
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width" [style.display]="getConfigurazione()?.Nome !== 'none' ? 'block' : 'none'">
        <mat-label>Nome</mat-label>
        <input matInput formControlName="Nome" name="Nome" required [readonly]="!isTipolavorazionemanuale()">
      </mat-form-field>
     
      <mat-form-field *ngIf="!isTipolavorazioneMateriali()" appearance="fill" class="full-width" [style.display]="getConfigurazione()?.Quantita !== 'none' ? 'block' : 'none'">
        <mat-label>Quantità</mat-label>
        <input matInput formControlName="Quantita" name="Quantita" [readonly]="isTipolavorazioneMateriali()" (keyup)="onQuantitaKeyup($event)">
      </mat-form-field>

      <mat-form-field *ngIf="!isTipolavorazioneMateriali()" appearance="fill" class="full-width" [style.display]="getConfigurazione()?.Importo !== 'none' ? 'block' : 'none'">
        <mat-label>Importo unitario</mat-label>
        <input matInput formControlName="Importo" name="Importo" [readonly]="isTipolavorazioneMateriali()" (keyup)="onImportoKeyup($event)">
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width" [style.display]="getConfigurazione()?.Sconto !== 'none' ? 'block' : 'none'">
        <mat-label>Sconto</mat-label>
        <input matInput formControlName="Sconto" name="Sconto" [readonly]="isTipolavorazioneMateriali()" (keyup)="onImportoKeyup($event)">
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width" [style.display]="getConfigurazione()?.Subtotale !== 'none' ? 'block' : 'none'">
        <mat-label>Importo unitario</mat-label>
        <input matInput formControlName="Subtotale" name="Subtotale" [readonly]="isTipolavorazioneMateriali()" (keyup)="onImportoKeyup($event)">
      </mat-form-field>


         <mat-form-field *ngIf="isTipolavorazioneMateriali()" style="padding-right:10px">
            <mat-label class="text-sm">Codice articolo</mat-label>
            <input matInput [(ngModel)]="filtroCodicearticolo" name="filtroCodicearticolo" (keyup)="onFiltroCodicearticoloKeyup($event)" class="text-sm">
         </mat-form-field>

         <mat-form-field *ngIf="isTipolavorazioneMateriali()" style="padding-right:10px">
            <mat-label class="text-sm">Descrizione</mat-label>
            <input matInput [(ngModel)]="filtroDescrizione" name="filtroDescrizione" (keyup)="onFiltroDescrizioneKeyup($event)" class="text-sm">
         </mat-form-field>

    <table *ngIf="isTipolavorazioneMateriali()"  mat-table [dataSource]="dataSource" class="mat-elevation-z8">
<!--
          <ng-container matColumnDef="sel">
              <th mat-header-cell *matHeaderCellDef>Seleziona</th>
              <td mat-cell *matCellDef="let articolo">
                  <mat-checkbox (change)="selezionato(articolo)"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="Id">
              <th mat-header-cell *matHeaderCellDef>Id
                <img src="./assets/images/sort.png" (click)="manageClick('Id')"/>
              </th>
              <td mat-cell *matCellDef="let articolo"> {{articolo.Id}} </td>
          </ng-container>
-->
          <ng-container matColumnDef="Codicearticolo">
              <th  mat-header-cell *matHeaderCellDef>Codice articolo
                <img src="./assets/images/sort.png" (click)="manageClick('Codicearticolo')"/>
              </th>
              <td  mat-cell *matCellDef="let articolo"> {{articolo.Codicearticolo}} </td>
          </ng-container>

          <ng-container matColumnDef="Descrizione">
              <th  mat-header-cell *matHeaderCellDef>Descrizione
                <img src="./assets/images/sort.png" (click)="manageClick('Descrizione')"/>
              </th>
              <td mat-cell *matCellDef="let articolo"> {{articolo.Descrizione}} </td>
          </ng-container>
<!--
          <ng-container matColumnDef="Categoria">
              <th mat-header-cell *matHeaderCellDef>Categoria
                <img src="./assets/images/sort.png" (click)="manageClick('Categoria')"/>
              </th>
              <td mat-cell *matCellDef="let articolo"> {{articolo.Categoria}} </td>
          </ng-container>
-->
          <ng-container matColumnDef="Costo">
              <th mat-header-cell *matHeaderCellDef>Costo
                <img src="./assets/images/sort.png" (click)="manageClick('Costo')"/>
              </th>
              <td mat-cell *matCellDef="let articolo"> {{articolo.Costo | number: '1.2-2' }} </td>
          </ng-container>

          <ng-container matColumnDef="Iva">
              <th mat-header-cell *matHeaderCellDef>IVA %
                <img src="./assets/images/sort.png" (click)="manageClick('Iva')"/>
              </th>
              <td mat-cell *matCellDef="let articolo"> {{articolo.Iva}} </td>
          </ng-container>

          <ng-container matColumnDef="Prezzo">
              <th mat-header-cell *matHeaderCellDef>Prezzo
                <img src="./assets/images/sort.png" (click)="manageClick('Prezzo')"/>
              </th>
              <td mat-cell *matCellDef="let articolo"> {{articolo.Prezzo | number: '1.2-2' }} </td>
          </ng-container>

          <ng-container matColumnDef="Giacenza">
              <th  mat-header-cell *matHeaderCellDef>Giacenza
                <img src="./assets/images/sort.png" (click)="manageClick('Giacenza')"/>
              </th>
              <td  mat-cell *matCellDef="let articolo"> {{articolo.Giacenza | number: '1.2-2' }} </td>
          </ng-container>

          <ng-container matColumnDef="Unitamisura">
              <th  mat-header-cell *matHeaderCellDef>Unita di misura
                <img src="./assets/images/sort.png" (click)="manageClick('Unitamisura')"/>
              </th>
              <td mat-cell *matCellDef="let articolo"> {{articolo.Unitamisura}} </td>
          </ng-container>

          <ng-container matColumnDef="add">
              <th mat-header-cell *matHeaderCellDef> Aggiungi </th>
              <td mat-cell *matCellDef="let articolo">
                <ng-container>
                  <mat-icon color="primary" (click)="addArticolo(articolo)">add_circle</mat-icon>
                </ng-container>
              </td>
          </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

  <mat-paginator *ngIf="isTipolavorazioneMateriali()" #paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>


   <!--   
      <table *ngIf="isTipolavorazioneMateriali()" mat-table [dataSource]="dataSource2" class="mat-elevation-z8">

          <ng-container matColumnDef="Quantita">
            <th mat-header-cell *matHeaderCellDef>Quantità</th>
            <td mat-cell *matCellDef="let lavorazionearticolo">
             
                <input matInput value="{{lavorazionearticolo.Quantita}}" (keyup)="onQuantitaLaKeyup(lavorazionearticolo,$event)">
    
            </td>
          </ng-container>

          <ng-container matColumnDef="Id">
            <th style="display:none" mat-header-cell *matHeaderCellDef>Id</th>
            <td style="display:none" mat-cell *matCellDef="let lavorazionearticolo"> {{lavorazionearticolo.Id}} </td>
          </ng-container>

          <ng-container matColumnDef="Codicearticolo">
            <th mat-header-cell *matHeaderCellDef>Codice articolo</th>
            <td mat-cell *matCellDef="let lavorazionearticolo"> {{lavorazionearticolo.Articolo.Codicearticolo}} </td>
          </ng-container>

          <ng-container matColumnDef="Descrizione">
            <th mat-header-cell *matHeaderCellDef>Descrizione</th>
            <td mat-cell *matCellDef="let lavorazionearticolo"> {{lavorazionearticolo.Articolo.Descrizione}} </td>
          </ng-container>

          <ng-container matColumnDef="Costo">
            <th mat-header-cell *matHeaderCellDef>Costo</th>
            <td mat-cell *matCellDef="let lavorazionearticolo"> {{lavorazionearticolo.Costo}} </td>
          </ng-container>

          <ng-container matColumnDef="Prezzo">
            <th mat-header-cell *matHeaderCellDef>Prezzo</th>
            <td mat-cell *matCellDef="let lavorazionearticolo">
             
                <input matInput value="{{lavorazionearticolo.Prezzo}}" (keyup)="onPrezzoKeyup(lavorazionearticolo, $event)">
           
          </td>
          </ng-container>

   

          <ng-container matColumnDef="Unitamisura">
            <th mat-header-cell *matHeaderCellDef>Unità di misura</th>
            <td mat-cell *matCellDef="let lavorazionearticolo"> {{lavorazionearticolo.Articolo.Unitamisura}} </td>
          </ng-container>

          <ng-container matColumnDef="Iva">
            <th mat-header-cell *matHeaderCellDef>IVA</th>
            <td mat-cell *matCellDef="let lavorazionearticolo"> {{lavorazionearticolo.Iva}} </td>

          </ng-container>

          <ng-container matColumnDef="Prezzototale">
            <th mat-header-cell *matHeaderCellDef>Prezzo totale</th>
            <td mat-cell *matCellDef="let lavorazionearticolo"> {{lavorazionearticolo.Prezzototale}} </td>
          </ng-container>

          <ng-container matColumnDef="save">
              <th mat-header-cell *matHeaderCellDef> Salva </th>
              <td mat-cell *matCellDef="let lavorazionearticolo">
                <button (click)="saveArticolo(lavorazionearticolo)">
               
                </button>
              </td>
          </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
        </table>
-->

    </form>


  </div >
 
  
 

        



</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onAnnulla()">Annulla</button>
  <button mat-button color="primary" (click)="onSalva()" [disabled]="registerForm.invalid">Salva</button>
</mat-dialog-actions>